import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-favorite-icon',
  templateUrl: './favorite-icon.component.html',
  styleUrls: ['./favorite-icon.component.scss']
})
export class FavoriteIconComponent implements OnInit {
  @Input() favorite: boolean;
  constructor() { }

  ngOnInit(): void {
  }

}
